import { TDropItem } from 'src/types';

export const testMaterialBuildingOptions: TDropItem[] = [
  { value: 'receivedMainOffice', label: 'Main Office' },
  { value: 'receivedLoadingDock', label: 'Loading Dock' },
  { value: 'receivedOther', label: 'Other:' },
];
